/**
 * Hook pour charger et gérer les disponibilités des utilisateurs
 */
import { useState, useEffect, useCallback } from 'react';
import { API_ENDPOINTS } from '../../../utils/apiConfig';

const useParticipantAvailability = ({
  users = [],
  currentDate,
  token,
  sessionId = null
}) => {
  const [userAvailability, setUserAvailability] = useState({});
  const [loading, setLoading] = useState(false);

  // Charger les disponibilités des utilisateurs
  const loadAvailability = useCallback(async () => {
    if (!currentDate || !token || users.length === 0) return;

    setLoading(true);
    try {
      const userIds = users.map(u => u.id);
      const response = await fetch(API_ENDPOINTS.USERS_BULK_AVAILABILITY, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          date: currentDate,
          user_ids: userIds,
          exclude_session_id: sessionId
        })
      });

      if (response.ok) {
        const data = await response.json();

        if (data.success && data.data?.users) {
          const availabilityMap = {};
          data.data.users.forEach(user => {
            availabilityMap[user.user_id] = {
              status: user.status,
              reason: user.reason,
              group_code: user.group_code,
              group_name: user.group_name,
              conflicting_sessions: user.status === 'busy' && user.group_code ? [{
                room_code: user.group_code,
                room_name: user.group_name
              }] : []
            };
          });

          setUserAvailability(availabilityMap);
        }
      }
    } catch (error) {
      console.error('Erreur chargement disponibilités:', error);
      // Fallback: tous disponibles
      const defaultAvailability = {};
      users.forEach(u => {
        defaultAvailability[u.id] = { status: 'available' };
      });
      setUserAvailability(defaultAvailability);
    } finally {
      setLoading(false);
    }
  }, [currentDate, token, users, sessionId]);

  useEffect(() => {
    loadAvailability();
  }, [loadAvailability]);

  return {
    userAvailability,
    loadingAvailability: loading,
    refreshAvailability: loadAvailability
  };
};

export default useParticipantAvailability;
